<template>
  <div class="page1">
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="false">
      <el-table-column fixed="right" label="操作" width="165px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="changeStatus(scope.row.signTemplateId, 1)"
              v-if="scope.row.status == 0">启用</el-button>
            <el-button type="text" @click="changeStatus(scope.row.signTemplateId, 0)"
              v-if="scope.row.status == 1">停用</el-button>
            <!--el-button type="text" @click="editTemplate(scope.row)">编辑</！el-button-->
            <el-button type="text" @click="editDialog(scope.row.signTemplateId)"
              v-if="scope.row.status == 1">发起流程</el-button>
          </div>
        </template>
      </el-table-column>
      <div slot="status" slot-scope="scope">
        {{ scope.data.status == 1 ? '启用' : '停用' }}
      </div>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="80%">
      <EForm :formColumns="formColumns" :rowSize="4" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
        ref="form" @onSearch="onSearch" :searchFlag="true" @getChange="changeSelect" :exportShow="false">
      </EForm>
      <ETable :tableTitle="tableTitle1" :tableData="tableData1" :needPagination="true" :count="count"
        @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size">
        <el-table-column fixed="right" label="操作" width="80px">
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click="setTemplate(scope.row)" :disabled="scope.row.status == 2">
                选择
              </el-button>
            </div>
          </template>
        </el-table-column>
      </ETable>
    </EDialog>
    <EDialog :dialogVisible="dialogVisible1" title="模板设置" @handleClose="handleClose1" width="50%"
      @handleClick="saveData">
      <el-table :data="tableData2" style="width: 100%;margin-bottom: 20px;" row-key="componentId" default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="componentName" label="控件名称" width="210">
        </el-table-column>
        <el-table-column label="合同属性" width="180">
          <template slot-scope="scope">
            <el-select v-model="scope.row.componentKey" clearable v-if="scope.row.participantFlag == ''"
              placeholder="请选择合同属性" @change="handleSelectChange">
              <el-option v-for="(key, value) in propAttrs" :key="key" :label="value" :value="value"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="控件值">
          <template slot-scope="scope" v-if="scope.row.participantFlag == ''">
            <el-date-picker v-model="scope.row.componentValue" :class="scope.row.className" type="date" v-if="scope.row.componentType == 3" style="width: 100%;" placeholder="选择日期" :format="scope.row.componentSpecialAttribute.dateFormat"
              :value-format="scope.row.componentSpecialAttribute.dateFormat" @change="handleInput" clearable>
            </el-date-picker>
            <el-select v-model="scope.row.componentValue" :class="scope.row.className" clearable v-else-if="scope.row.componentType == 9||scope.row.componentType == 10||scope.row.componentType == 14" style="width: 100%;" placeholder="请选择合同属性"
              @change="handleInput">
              <el-option v-for="item in scope.row.componentSpecialAttribute.options" :key="item.optionContent"
                :label="item.optionContent" :value="item.optionOrder"></el-option>
            </el-select>
            <el-input v-model="scope.row.componentValue" :class="scope.row.className" v-else @input="handleInput" :maxlength="scope.row.componentSpecialAttribute.componentMaxLength" show-word-limit></el-input>
            
          </template>
        </el-table-column>
      </el-table>
      <div style="font-weight: bold; background-color: #dedede; padding: 10px 10px 10px 10px; margin-bottom: 15px;">
        参与者：
      </div>
      <el-form inline label-width="130px" label-position="left" :model="form1" style="padding-left: 10px;">
        <el-row v-for="(row, index) in participants" :key="index">
          <el-col :span="24" v-if="row.participantType==1">
            <el-form-item :label="row.participantFlag+':'">
              <div style="float: left;" v-if="indexOfString(row.participantFlag,'甲方')">
                <el-select v-model="row.transactorName" clearable placeholder="签署人" style="width: 110px;" @change="handleSelectChange1">
                  <el-option v-for="item in members" :key="item.transactorName" :label="item.transactorName"
                    :value="item.transactorName"></el-option>
                </el-select>
                <div style="padding-left: 20px;float: right;">
                {{ row.orgName }}　{{ row.transactorName }}　{{ row.transactorPsnAccount }}</div>
              </div>
              <div style="float: left;" v-if="indexOfString(row.participantFlag,'乙方')">
                <div style="float: left;">
                {{ row.orgName }}　{{ row.transactorName }}　{{ row.transactorPsnAccount }}</div>
              </div>
              
            </el-form-item>
          </el-col>
          <el-col :span="24" v-else-if="row.participantType==2">
            <el-form-item :label="row.participantFlag+':'">
              <div>{{ row.psnName }}　{{ row.psnAccount }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <!--el-row>
          <el-col :span="24">
            <el-form-item label="企业签署方：">
              <div style="float: left;">
                <el-select v-model="form1.member" clearable placeholder="签署人" style="width: 110px;"
                  @change="handleSelectChange1">
                  <el-option v-for="item in members" :key="item.transactorName" :label="item.transactorName"
                    :value="item.transactorName"></el-option>
                </el-select>
              </div>
              <div style="float: left; padding-left: 20px;">
                {{ member.orgName }}　{{ member.transactorName }}　{{ member.transactorPsnAccount }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="个人签署方：">
              <div>{{ member.psnName }}　{{ member.psnAccount }}</div>
            </el-form-item>
          </el-col>
        </el-row-->

      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable';
import Http from '@/service/http';
import EDialog from '@/components/EDialog';
import EButton from '@/components/EButton';
import { otherMixin } from '@/components/mixin';
import EForm from '@/components/EForm'
import { mapGetters } from 'vuex'
export default {
  name: 'shopInfo',
  mixins: [otherMixin],
  data() {
    return {
      tableTitle: [
        {
          label: '模板名称',
          prop: 'signTemplateName',
        },
        {
          label: '创建日期',
          prop: 'createTime',
        },
        {
          label: '更新时间',
          prop: 'updateTime',
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot'
        }
      ],
      tableData: [],
      form: {
        name: null,
        mobile: null,
        cardNo: null,
        createTimeStart: null,
        createTimeEnd: null,
        isCertification: null,
        current: 1,
        size: 10,
      },
      count: null,
      exportData: {},
      dialogVisible: false,
      title: '发起流程',

      formColumns: [
        {
          title: '摊位号',
          type: 'text',
          property: 'boothCode',
          show: true
        },
        {
          title: '负责人 ',
          type: 'text',
          property: 'signPerson',
          show: true
        },
        {
          title: '合同编号',
          type: 'text',
          property: 'contractCode',
          show: true
        },
        {
          title: '合同签订开始时间',
          type: 'datePicker',
          property: 'createTimeStart',
          show: true
        },
        {
          title: '区域',
          type: 'select',
          property: 'areaId',
          show: true,
          options: []
        },
        {
          title: '商户类型',
          type: 'select',
          property: 'tenantType',
          show: true,
          options: [
            {
              label: '全部',
              value: '',
            },
            {
              label: '个体',
              value: 1,
            },
            {
              label: '公司',
              value: 2,
            },
            {
              label: '其他',
              value: 3,
            }
          ]
        },
        {
          title: '合同状态',
          type: 'select',
          property: 'status',
          show: true,
          options: [
            {
              label: '全部',
              value: '',
            },
            {
              label: '执行中',
              value: 1,
            },
            {
              label: '已退租',
              value: 2,
            },
            {
              label: '已续签',
              value: 3,
            }
          ]
        },
        {
          title: '合同签订截止时间',
          type: 'datePicker',
          property: 'createTimeEnd',
          show: true
        },
        {
          title: '位置',
          type: 'select',
          property: 'placeId',
          show: true,
          options: []
        },
        {
          title: '身份证号 ',
          type: 'text',
          property: 'idCard',
          show: true
        },
      ],
      tableTitle1: [
        {
          label: '合同编号',
          prop: 'contractCode'
        },
        {
          label: '商户名称',
          prop: 'tenantName'
        },
        {
          label: '区域',
          prop: 'areaName'
        },
        {
          label: '位置',
          prop: 'placeName',
        },
        {
          label: '摊位号',
          prop: 'boothCode'
        },
        {
          label: '面积',
          prop: 'areas'
        },
         {
          label: '负责人',
          prop: 'signPerson'
        },
        {
          label: '联系电话',
          prop: 'tenantPhone'
        },
        {
          label: '身份证号',
          prop: 'idCard'
        },
        {
          label: '合同签订人',
          prop: 'createUserCn'
        },
        {
          label: '合同签订时间',
          prop: 'createTime'
        },
        {
          label: '合同状态',
          prop: 'statusCn'
        }
      ],
      searchForm: {
        boothCode: null,
        signPerson: null,
        contractCode: null,
        createTimeStart: null,
        areaId: null,
        tenantType: null,
        status: null,
        createTimeEnd: null,
        placeId: null,
        idCard: null,
        createUser: null,
        current: 1,
        size: 10,
      },
      tableData1: [],

      dialogVisible1: false,

      signTemplateId: null,

      tableData2: [],
      form1: {},

      propAttrs: [],
      members: [],
      member: {},
      contract: {},
      participants: []//参与者
    };
  },
  watch: {},
  created() {
    this.getData();

  },
  components: { ETable, EDialog, EButton, EForm },
  computed: {
    ...mapGetters(['buttonList']),
  },
  beforeMount() { },
  methods: {
    indexOfString(text1, text2){
      if(text1.indexOf(text2)==-1){
        return false
      }else{
        return true
      }
    },
    async editTemplate(row) {
      this.dialogVisible1 = true
      let that = this
      let res = await Http.esignTemplateInfo({ signTemplateId: row.signTemplateId });
      if (res.code == 200) {
        that.tableData2 = res.data
        that.propAttrs = row
      } else {
        that.$message.error(res.msg);
      }
    },
    async setTemplate(row) {
      this.dialogVisible1 = true
      let that = this
      
      that.contract = row
      that.member = {}
      that.member.orgName = that.contract.tenantName
      that.member.transactorName = that.contract.signPerson
      that.member.transactorPsnAccount = that.contract.phone
      that.member.psnName = that.contract.signPerson
      that.member.psnAccount = that.contract.phone

      that.form1 = {}

      let res = await Http.esignTemplateInfo({ signTemplateId: that.signTemplateId });
      if (res.code == 200) {
        that.tableData2 = res.data
        that.participants = []
        if (that.tableData2 != null && that.tableData2.length) {
          var obj = null
          for (let i = 0; i < that.tableData2.length; i++) {
            //console.log(that.tableData2[i].participantId)
            obj = {}
            obj.participantId = that.tableData2[i].participantId
            obj.participantFlag = that.tableData2[i].participantFlag
            obj.participantType = that.tableData2[i].participantType
            obj.required = that.tableData2[i].required
            obj.participantSetMode = that.tableData2[i].participantSetMode
            obj.orgName = ""
            obj.transactorName = ""
            obj.transactorPsnAccount = ""
            if(that.tableData2[i].participantType==='2'){
              obj.orgName = ""
              obj.transactorName = ""
              obj.transactorPsnAccount = ""
              obj.psnName = that.member.psnName
              obj.psnAccount = that.member.psnAccount
            }else{
              if(that.indexOfString(obj.participantFlag,'甲方')){
                obj.orgName = ""
                obj.transactorName = ""
                obj.transactorPsnAccount = ""
              }else{
                obj.orgName = that.member.orgName
                obj.transactorName = that.member.transactorName
                obj.transactorPsnAccount = that.member.transactorPsnAccount
              }
              
              obj.psnName = ""
              obj.psnAccount = ""
            }
            if(obj.participantSetMode==1||obj.participantSetMode==4){
              that.participants.push(obj)
            }
            
          }
        }
      } else {
        that.$message.error(res.msg);
      }
      let res1 = await Http.esignContractInfo({ id: row.contractId });
      if (res1.code == 200) {
        that.propAttrs = res1.data
        let components = null

        if (that.tableData2 != null && that.tableData2.length) {
          for (let i = 0; i < that.tableData2.length; i++) {
            components = that.tableData2[i].children
            if (components != null && components.length > 0) {
              for (let j = 0; j < components.length; j++) {
                //components[j].componentKey = ""
                components[j].className = ""
                Object.keys(that.propAttrs).forEach((key) => {
                  if (components[j].componentName === key) {
                    components[j].componentValue = that.propAttrs[key]
                    //components[j].componentKey = key
                  }
                });
              }
            }
            //处理空显示
            if (components != null && components.length > 0) {
              for (let j = 0; j < components.length; j++) {
                if(components[j].required=='true'&&(components[j].componentValue==null||components[j].componentValue+''=='')){
                  components[j].className = 'custom_css'
                }else{
                  components[j].className = ''
                }
              }
            }
          }
        }

      } else {
        that.$message.error(res1.msg);
      }

      //拿到界面加载时提示获取
      /**
      let res2 = await Http.memberList();
      if (res2.code == 200) {
        that.members = res2.data
      }else{
        that.$message.error(res2.msg);
      }
      **/
    },
    handleSelectChange1(val) {
      let m = {
        transactorName:'',
        participantId:'',
        orgName:'',
        transactorPsnAccount:''
      }
      if (this.members != null && this.members.length > 0) {
        for (let i = 0; i < this.members.length; i++) {
          if (this.members[i].transactorName === val) {
            m = this.members[i]
            break
          }
        }
      }
      if (this.participants != null && this.participants.length > 0) {
        for (let j = 0; j < this.participants.length; j++) {
          if (this.participants[j].transactorName === m.transactorName) {
            //this.participants[j].participantId = m.participantId
            this.participants[j].orgName = m.orgName
            this.participants[j].transactorPsnAccount = m.transactorPsnAccount
            this.participants[j].transactorName = m.transactorName
            //break
          }
        }
      }
    },
    handleSelectChange(val) {
      let that = this
      let components = null

      if (that.tableData2 != null && that.tableData2.length) {
        for (let i = 0; i < that.tableData2.length; i++) {
          components = that.tableData2[i].children
          if (components != null && components.length > 0) {
            for (let j = 0; j < components.length; j++) {
              if (components[j].componentKey === val) {
                components[j].componentValue = that.propAttrs[val]
              }
            }
          }
        }
      }
    },
    handleInput(val) {
      let that = this
      let components = null
      if (that.tableData2 != null && that.tableData2.length) {
        for (let i = 0; i < that.tableData2.length; i++) {
          components = that.tableData2[i].children
          if (components != null && components.length > 0) {
            for (let j = 0; j < components.length; j++) {
              if (components[j].componentValue === val) {
                that.changeValueByName(components[j].componentName, val)
              }
            }
          }
        }
      }
    },
    changeValueByName(name, val) {
      let that = this
      let components = null
      if (that.tableData2 != null && that.tableData2.length) {
        for (let i = 0; i < that.tableData2.length; i++) {
          components = that.tableData2[i].children
          if (components != null && components.length > 0) {
            for (let j = 0; j < components.length; j++) {
              if (components[j].componentName === name) {
                components[j].componentValue = val
                if(components[j].required=='true'&&(components[j].componentValue==null||components[j].componentValue+''=='')){
                  components[j].className = 'custom_css'
                }else{
                  components[j].className = ''
                }
              }
            }
          }
        }
      }
    },
    handleClose1() {
      this.dialogVisible1 = false
    },
    changeSelect(prop) {
      if (prop == 'areaId') {
        this.getPlaceLabel()
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    editDialog(signTemplateId) {
      this.signTemplateId = signTemplateId
      this.dialogVisible = true
    },
    async saveData() {
      let that = this

      let param = {
        signTemplateId: that.signTemplateId,
        signFlowTitle: that.contract.tenantName+"（" + that.contract.boothCode + "）",
        signUsers: that.participants,
        esignConfigs: that.tableData2,
        contractId: that.contract.contractId,
        contractNo: that.contract.contractCode
      }

      let result = false
      if (that.tableData2 != null && that.tableData2.length) {
        let components = null
        for (let i = 0; i < that.tableData2.length; i++) {
          components = that.tableData2[i].children
          if (components != null && components.length > 0) {
            for (let j = 0; j < components.length; j++) {
              if(components[j].required=='true'&&(components[j].componentValue==null||components[j].componentValue+''=='')){
                result = true
                break
              }              
            }
          }
        }
      }
      if(result){
        that.$message.error("尚有未填写的信息，请完成后再试！");
        return
      }

      let res = await Http.createBySignTemplate(param);
      if (res.code == 200) {
        this.dialogVisible1 = false
        this.dialogVisible = false
        that.$message.success(res.msg);
      } else {
        that.$message.error(res.msg);
      }
    },
    async toChangeStatus(param) {
      let that = this
      let res = await Http.changeStatus(param);
      if (res.code == 200) {
        that.$message.success(res.msg);
        setTimeout(function () {
          that.getData();
        }, 2000);
        //
      } else {
        that.$message.error(res.msg);
      }
    },
    changeStatus(signTemplateId, status) {
      this.$messageBox
        .confirm(`确定执行该操作吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          let param = {
            signTemplateId: signTemplateId,
            status: status
          }
          this.toChangeStatus(param)
        })
        .catch((res) => { });
    },
    onSearch() {
      this.searchForm.current = 1
      this.getContractData();
    },
    changePage(current) {
      this.searchForm.current = current
      this.getContractData();
    },
    changeSize(size) {
      this.getData();
    },

    async getData() {
      let that = this
      let res = await Http.esignTemplateList();
      if (res.code == 200) {
        that.tableData = res.data;
      }

      let res2 = await Http.memberList();
      if (res2.code == 200) {
        that.members = res2.data
      } else {
        that.$message.error(res2.msg);
      }
    },

    async getContractData() {
      let res = await Http.cmcontractmanage(this.searchForm)
      if (res.code == 200) {
        this.tableData1 = res.data.records
        this.count = res.data.total
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ws {
  width: 100%;
}
.custom_css ::v-deep .el-input__inner {
  border: 1px solid #ff0000 !important;
}
</style>
